import { ICriteria } from './criteria.interface';

export interface ISaveReportResponse {
  criteria: ICriteria[];
  direction: string;
  fields: string[];
  id: number;
  name: string;
  orderCriteria: string;
  organization: string;
  pageNumber: number;
  pageSize: number;
  query: string;
  source: string;
  useEntityService: number;
}
